var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.57214 0.959385C6.90887 0.124704 8.09059 0.124704 8.42732 0.959385L9.71913 4.16149C9.76632 4.27847 9.87549 4.3588 10.0012 4.36905L13.246 4.63382C14.1259 4.70561 14.4881 5.79879 13.8253 6.38177L11.363 8.54735C11.2719 8.6275 11.2315 8.75082 11.2576 8.86934L12.045 12.4482C12.2417 13.3421 11.2336 14.0088 10.488 13.4779L7.69311 11.4879C7.57736 11.4055 7.4221 11.4055 7.30635 11.4879L4.51148 13.4779C3.76581 14.0088 2.75779 13.3421 2.95447 12.4482L3.74184 8.86934C3.76791 8.75082 3.72753 8.6275 3.63641 8.54735L1.17409 6.38179C0.511232 5.79881 0.873487 4.70561 1.75331 4.63382L4.99825 4.36905C5.12397 4.3588 5.23314 4.27847 5.28033 4.16149L6.57214 0.959385Z",
    fill: "#6B92FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.1073ea6d.svg";
export { ForwardRef as ReactComponent };